
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { DispatchSearch } from '../DispatchSearch';
import { v_DispatchSearchBus } from '../models/v_DispatchSearchBus';
import { WidgetSearch } from '../models/WidgetSearch';
import { AttachmentBus } from '../models/AttachmentBus';
import { FileInfo } from '@progress/kendo-angular-upload';
import { SearchTarget } from '../enums/SearchTarget';
import { PdfResponse } from '../models/PdfResponse';

@Injectable()
export class QuoteService extends BaseService {

  constructor(_http: HttpClient) {
    super(_http);
    this.baseUrl = this.rootUrl + "Quote/";
    }
    get(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "Get/" + Id;
        return super.get(url_call);
    }

    getAdditionalData(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAdditionalData/" + id
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    getFromNumber(number: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetFromNumber/" + number;
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    getAttachments(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAttachments/" + id;
        return super.get(url_call); // this._http.get(url_call); //, { headers: headers }); //, { headers: headers });
    }
    getDocument(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDocument/" + id;
        return super.get(url_call); // this.get(url_call); //, { headers: headers });
    }
    getQuoteEquipment(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuoteEquipment/" + id;
        return super.get(url_call); // this.get(url_call); //, { headers: headers });
    }
    getQuoteStatusHistory(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuoteStatusHistory/" + id;
        return super.get(url_call); // this.get(url_call); //, { headers: headers });
    }
    getVQuoteNotes(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetV_QuoteNotes/" + id;
        return super.get(url_call); // this.get(url_call); //, { headers: headers });
    }
    getQuoteDefaultsFromLocation(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuoteDefaultsFromLocation/" + id;
        return super.get(url_call);
    }

    saveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAll";
        return this._http.put(url_call, model, { headers });
    }
    saveAllSQL(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAllSQL";
        return this._http.put(url_call, model, { headers });
    }
    saveQuote(userId: any, model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAndReturn/"+userId;
        return this._http.put(url_call, model, { headers });
    }

    saveQuoteNote(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "QuoteNote_Save";
        return this._http.put(url_call, model, { headers });
    }
    saveQuoteInvoice(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "QuoteInvoice_Save";
        return this._http.put(url_call, model, { headers });
    }
    saveQuoteEquipment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveQuoteEquipment";
        return this._http.put(url_call, model, { headers });
    }
    deleteQuoteEquipment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteQuoteEquipment/" + id;
        return this._http.delete(url_call, { headers });
    }

    saveQuoteNoteTest(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "QuoteNote_TestSave";
        return this._http.put(url_call, model, { headers });
    }
    getStatusDetailByWidgetSearch(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetStatusDetailByWidgetSearch"
        return this._http.get(url_call, options);
    }
    saveQuoteTemplate(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveQuoteTemplate";
        return this._http.put(url_call, model, { headers });
    }
    getQuoteFromTemplate(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuoteFromTemplate/" + id;
        return super.get(url_call);
    }

    getQuoteNormalOrPotentialLocationGeo(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuoteNormalOrPotentialLocationGeo/" + id;
        return super.get(url_call);
    }

    createNewFromDispatch(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateNewFromDispatch/" + id;
        return super.get(url_call);
    }
    createNewFromInvoice(id: any): Observable<any> {
        let url_call: string = this.baseUrl + "CreateNewFromInvoice/" + id;
        return super.get(url_call);
    }
    createQuoteLineFrom(fromTarget: SearchTarget, id: string, detailType: number, detailId: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateQuoteLineFrom/" + fromTarget + "/" + id + "/" + detailType + "/" + detailId;
        return super.get(url_call);
    }
    deleteQuote(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteQuote/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteQuoteInvoice(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteQuoteInvoice/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteQuoteNote(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteQuoteNote/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteQuoteAttachment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteQuoteAttachment/" + id;
        return this._http.delete(url_call, { headers });
    }
    print(id: any): Observable<any> {
        let url_call: string = this.baseUrlCPConn + "PrintQuote/" + id;
        return super.get(url_call);
    }

    //calls 2.2 new pdf engine endpoint
    printUsingIronPdf(id: string): Observable<PdfResponse> {
        let url: string = this.baseUrl + id + "/pdf";
        return super.get(url);
    }

    uploadAttachment(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "UploadAttachment";
        //we dont need to send the bytes if its filled out cause we are posting the file
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", JSON.stringify(data));

        return this._http.put(url, formData);
    }
    importBid2(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "ImportBid/" + id
        return super.get(url_call);
    }
    importBid(files: FileInfo[], data: AttachmentBus, userId: any, companyId: any, taxCodeId:any): Observable<any> {
        let url: string = this.baseUrl + "ImportBid";
        //we dont need to send the bytes if its filled out cause we are posting the file
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", JSON.stringify(data));
        formData.append("TaxCodeId", taxCodeId);

        return this._http.put(url, formData);
    }
    getListFromMaster(masterId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetListFromMaster/" + masterId;
        return super.get(url_call);
    }
    createNewDispatchFromQuote(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateNewDispatchFromQuote/" + id;
        return super.get(url_call);
    }
    getTaxCode(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetTaxCode/" + id
        return super.get(url_call);
    }
    getBidsheetData(id) {
        const base_call = this.rootUrl + 'bidsheet/'
        let url_call: string = base_call + "GetBidsheetsByQuoteId/" + id;
        return super.get(url_call);
    }

    getConstructionBidNCStatus(jobId: string, classId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetConstructionBidNCStatus/" + jobId + "/" +classId
        return super.get(url_call);
    }

    getAvalaraTaxRate(id: string) {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetAvalaraTaxRate/" + id;
        return this._http.get(url_call, { headers });
    }
}
